// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YWDq","expireSoon":"styles_expireSoon__-7rR3"};